module.exports = __webpack_public_path__ + "static/media/airbtics_pro_us_cover.eb9aacfd.jpg";